import { EnvironmentProviders, importProvidersFrom, makeEnvironmentProviders } from '@angular/core';

import { DeviceBehaviorPluginsModule } from '@shure/shared/angular/device-behavior/core';

import { DefaultCdmDeviceBehaviorPlugin } from './default-cdm.device-behavior';
import { Mxa920CdmDeviceBehaviorPlugin } from './mxa920-cdm.device-behavior';

export function provideDeviceUiPlugins(): EnvironmentProviders {
	return makeEnvironmentProviders([
		importProvidersFrom(
			DeviceBehaviorPluginsModule.forRoot([Mxa920CdmDeviceBehaviorPlugin], DefaultCdmDeviceBehaviorPlugin)
		)
	]);
}
